"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Function to get locale text by Id or En
 * @param {string} id
 * @param {string} en
 * @returns {LocaleResult}
 */
function getLocale(id, en) {
    return {
        id: id,
        en: en,
    };
}
exports.default = getLocale;
